import React, { useState } from 'react';
import BrushAndZoomComponent from '../../../Views/component/BrushAndZoomComponent';
import { getDataMeasures, loaderForGraphics } from './detailsHelper';

// show graphics for do or tp detail
export const DoTpGraphicsContainer = (props) => {
  const typeData = props.code?.includes('DO') ? 'DO' : 'TP';
  const titleTempGraphic = 'Temps de déversement sur le ' + typeData;
  const titleNumberGraphic = 'Nombre de déversements sur le ' + typeData;
  const titleVolumeGraphic = 'Volume déversé sur le ' + typeData;
  const [zoomDomainTemp, setZoomDomainTemp] = useState<any>({
    x: [new Date(1990, 1, 1), new Date(2009, 1, 1)],
  });
  const [zoomDomainNumber, setZoomDomainNumber] = useState<any>({
    x: [new Date(1990, 1, 1), new Date(2009, 1, 1)],
  });

  // handler of zooming
  const handleZoomContainer = (domain) => {    
    domain !== undefined &&
      setZoomDomainTemp({ ...zoomDomainTemp, x: domain.x });
    domain !== undefined &&
      setZoomDomainNumber({ ...zoomDomainNumber, x: domain.x });
  };
  
  return (
    <>
      <div style={{ display: 'inline-flex' }}>
        {/* temp graphic */}
        <div style={{ marginRight: '10px'}}>
          {props.data.allMeasures !== null ?
            <BrushAndZoomComponent
              data={getDataMeasures(typeData, 'time', props.data.allMeasures)}
              title={titleTempGraphic}
              automatedTestId='dataTemps-chart'
              pluvioData={props.data.allMeasures.pluvioList}
              dataSelected={props.dataSelected}
              axisXLabel='Date'
              axisYLabel='Temps (h)'
              axisYLabelPluvio='Quantité (mm)'
              showHide={props.showHide['dataTemps-chart']}
              handleShowHide={props.handleShowHideGraphics}
              legend={[
                {
                  name: 'Déversement',
                  symbol: { fill: '#85929E' },
                },
                {
                  name: 'Pluviométrie',
                  symbol: { fill: '#85C1E9' },
                },
              ]}
              mode='solo'
              zoomMode='synchro'
              typeOfGraphic='bar'
              handleZoomContainer={handleZoomContainer}
              zoomDomain={zoomDomainTemp}
            /> : loaderForGraphics('74vh', '55vh', 'loaderDoTpGraphics')}
        </div>
        {/* number graphic */}
        <div style={{ marginLeft: '10px' }}>
          {props.data.allMeasures !== null ?
            <BrushAndZoomComponent
              data={getDataMeasures(typeData, 'nb', props.data.allMeasures)}
              title={titleNumberGraphic}
              automatedTestId='dataNombre-chart'
              axisXLabel='Date'
              axisYLabel='Nombre'
              showHide={props.showHide['dataNombre-chart']}
              dataSelected={props.dataSelected}
              handleShowHide={props.handleShowHideGraphics}
              legend={[
                {
                  name: 'Déversement',
                  symbol: { fill: '#85929E' },
                },
              ]}
              mode='solo'
              zoomMode='synchro'
              typeOfGraphic='bar'
              handleZoomContainer={handleZoomContainer}
              zoomDomain={zoomDomainNumber}
            />  : loaderForGraphics('74vh', '55vh', 'loaderDoTpGraphics')}
        </div>
      </div>
      <br />
      {/* volume graphics */}
      <div style={{ alignSelf: 'center' }}>
        <div style={{ width: 'max-content', marginTop: '10px' }}>
          {props.data.allMeasures !== null ?
            <BrushAndZoomComponent
              data={getDataMeasures(typeData, 'volume', props.data.allMeasures)}
              title={titleVolumeGraphic}
              pluvioData={props.data.allMeasures.pluvioList}
              dataSelected={props.dataSelected}
              automatedTestId='dataVolume-chart'
              axisXLabel='Date'
              axisYLabel='Volume (m³)'
              showHide={props.showHide['dataVolume-chart']}
              handleShowHide={props.handleShowHideGraphics}
              legend={[
                {
                  name: 'Volume',
                  symbol: { fill: '#85929E' },
                },
                {
                  name: 'Pluviométrie',
                  symbol: { fill: '#85C1E9' },
                },
              ]}
              zoomMode='alone'
              mode='solo'
              typeOfGraphic='bar'
            />
           : loaderForGraphics('74vh', '55vh', 'loaderDoTpGraphics')}
        </div>
      </div>
    </>
  );
};
